// removed by extract-text-webpack-plugin
module.exports = {"primary":"#cb4b32","secondary":"#5f97a9","tertiary":"#f5f5f5","empty":"repeating-linear-gradient(45deg, #606dbc, #606dbc 10px, #465298 10px, #465298 20px)"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Key.css
// module id = 612
// module chunks = 0